import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalGenericComponent } from '../../../shared/components/modal-generic/modal-generic.component';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { GtmService } from '../../../shared/services/gtm/gtm.service';
import { UserDataService } from '../../../shared/services/user-data/user-data.service';
import { MIN_STATUS } from '../../../shared/utils/constants';
import { ConfirmationService } from '../../../vass-core/components/modal/confirmation.service';
import { CommonService } from '../../../vass-core/services/common.service';
import { DocumentSaveModel } from '../../models/documentSave.model';
import { AskStateService } from '../../services/ask-state/ask-state.service';
import { DocumentationService } from '../../services/documentation/documentation.service';

import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss'],
  standalone: false,
})
export class DocumentationComponent implements OnInit, OnDestroy {
  public documentation: any;
  public listDocumentationSave: Array<DocumentSaveModel>;
  public httpError: boolean = false;
  public showSentDocuments: boolean = false;
  public filesNotType: boolean = false;
  public status: number;
  public listStatus = MIN_STATUS;
  public firstHolder = '';
  public secondHolder = '';
  public titleFilesCommon = '';
  private subscription = new Subscription();

  constructor(
    private confirmationService: ConfirmationService,
    private documentationService: DocumentationService,
    private _userDataService: UserDataService,
    private _commonService: CommonService,
    private authService: AuthService,
    private askStateService: AskStateService,
    private translate: TranslateService,
    private gtm: GtmService,
  ) {}

  ngOnInit() {
    this.getDocumentation();
    this.getStatus();
  }

  private getStatus() {
    this.subscription.add(
      this.authService
        .getStatus()
        .pipe(distinctUntilChanged())
        .subscribe((status) => {
          this.status = parseFloat(status);
          this.gtm.sendVarGTM({ pageType: 'Envío de documentación' });
        }),
    );
  }

  getDocumentation() {
    this.documentationService.getDocumentation().subscribe(
      (documentation) => {
        this.documentation = documentation.listDocuments;
        this.firstHolder = this.getNameholder(0);
        this.secondHolder = this.getNameholder(1);
        this.titleFilesCommon = this.translate.instant('documentation_documents_of', {
          holder: this._userDataService.getUserData().level2Data.holders[0].name,
        });
        if (this._userDataService.getUserData().level2Data.holders[1]) {
          this.titleFilesCommon =
            this.titleFilesCommon +
            ` & ${this._userDataService.getUserData().level2Data.holders[1].name}`;
        }

        this.filesNotType = documentation.filesNotType;
        if (this.filesNotType && !localStorage.getItem('oldDocumentation')) {
          this.openModalNewDocumentation();
        }
      },
      (error) => {
        this.httpError = true;
      },
    );
  }

  getNameholder(holder: number) {
    if (
      this._userDataService.getUserData().level2Data.holders &&
      this._userDataService.getUserData().level2Data.holders[holder]
    ) {
      return `${this._userDataService.getUserData().level2Data.holders[holder].name} ${
        this._userDataService.getUserData().level2Data.holders[holder].firstSurname
      }
                     ${
                       this._userDataService.getUserData().level2Data.holders[holder]
                         .secondSurname
                     }`;
    } else {
      return 'Titular ' + (holder + 1);
    }
  }

  openConfirmModal() {
    const data = {
      message: this.translate.instant('document_document_info_modal_finish_upload'),
      txtButton: 'btn_aceptar',
      txtButtonCancel: 'btn_cancel',
    };
    const options: Object = {
      header: this.translate.instant('document_document_title_modal_finish_upload'),
      showHeader: true,
      closeOnEscape: true,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
    };

    this.confirmationService.confirm(<any>{
      component: ModalGenericComponent,
      options: options,
      data: data,
      accept: (data) => {
        this.finishUploadDocuments();
      },
      reject: () => {},
    });
  }

  finishUploadDocuments() {
    this.documentationService.finishUploadDocuments().subscribe(
      (data) => {
        // Recuperar eventos
        this.status = data.status;
        this.authService.updateStatus(true);
        this.gtm.sendEventGTM({
          event: 'interaccion',
          eAction: 'tasacion',
          eLabel: 'confirmar_documentos',
        });
      },
      (err) => {
        this.openConfirmModal();
      },
    );
  }

  openModalGeneric(status: string) {
    const titleModal = this.translate.instant('documentation_documents_modal_title');
    const message = 'documentation_documents_modal_msg';

    const data = {
      message: message,
    };
    const options: Object = {
      header: titleModal,
      showHeader: true,
      closeOnEscape: true,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
    };

    this.confirmationService.confirm(<any>{
      component: ModalGenericComponent,
      options: options,
      data: data,
      accept: (data) => {},
      reject: () => {},
    });
  }

  openModalNewDocumentation() {
    const options: Object = {
      txtButton: '',
      showHeader: true,
      header: '',
      closeOnEscape: false,
      closable: true,
      styleClass: 'modal-class',
      cancelButton: false,
      acceptButton: false,
    };

    const data = {
      message: 'documentation_documents_old_modal_msg',
      showIcon: true,
    };

    this.confirmationService.confirm(<any>{
      component: ModalGenericComponent,
      options,
      data: data,
      accept: () => {
        localStorage.setItem('oldDocumentation', 'true');
      },
      reject: () => {
        localStorage.setItem('oldDocumentation', 'true');
      },
    });
  }

  canFinishUpload() {
    if (this.filesNotType) {
      this.openConfirmModal();
      return;
    }
    let valid = true;
    this.documentation.forEach((element) => {
      element.common.forEach((e) => {
        if (e.mandatory && e.totalFiles === 0) {
          e.hasError = true;
          valid = false;
        }
      });
      element.firstHolder.forEach((e) => {
        if (e.mandatory && e.totalFiles === 0) {
          e.hasError = true;
          valid = false;
        }
      });
      element.secondHolder.forEach((e) => {
        if (e.mandatory && e.totalFiles === 0) {
          e.hasError = true;
          valid = false;
        }
      });
    });

    if (!valid) {
      this._commonService.sendNotification({
        key: 'send-manager-error',
        severity: 'error',
        position: 'top-center',
        summary: this.translate.instant('documentation_documents_toast_error_send_title'),
        time: 5000,
        detail: this.translate.instant('documentation_documents_toast_error_send_msg'),
      });
    } else {
      this.openConfirmModal();
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
